export default "__VITE_ASSET__e56VktrR__"